export default (state: any) => {
  const user = () => {
    return state.user
  }

  return {
    user,
  }
}
